export const LabelText = {
  title: 'pandapro',
  altTitle: 'foodora PRO',
  subtitle: 'Subscribe your employees to enjoy bigger and better deals',
  subtitleCta: 'See our subscription plans',
  SUBSCRIBE_BUTTON: 'Subscribe',
  tabSubscribe: 'Subscribed',
  tabUnsubscribe: 'Not subscribed',
  unsubscribeModal: {
    confirmButton: 'Unsubscribe',
    cancelButton: 'Back to Subscriptions'
  },
  subscribeModal: {
    confirmButton: 'Confirm',
    cancelButton: 'Back to Subscriptions'
  },
  tab: {
    subscribed: 'Subscribed',
    unsubscribed: 'Not Subscribed'
  },
  subscribePageComponent: {
    title: 'Subscribe to pandapro',
    altTitle: 'Subscribe to foodora PRO',
    button: 'Subscribe'
  },
  SUBSCRIBED_LISTING: {
    CTA_TITLE: 'No results found',
    CTA_SUBTITLE: 'Try adjusting your search or filter',
    CTA_BUTTON: 'Show all items'
  },
  UNSUBSCRIBED_LISTING: {
    CTA_TITLE: "You're a team of pros",
    CTA_SUBTITLE: 'Amazing, your team has full access to pro perks!',
    CTA_BUTTON: 'Show all items'
  },
  SUBSCRIBE_CONFIRM_MODAL: {
    TITLE: 'Confirm subscriptions',
    CONFIRM_BUTTON: 'Confirm',
    CANCEL_BUTTON: 'Back to Subscriptions'
  }
};

export const TestId = {
  icon: {
    subscribe: 'ic-subscribe',
    unsubscribe: 'ic-unsubscribe'
  }
};
